import InputSmart from './InputSmart';

export default InputSmart;
